import * as REMINDER from '@/store/constants/reminder';

export default {
  [REMINDER.GET_REMINDER_LIST]: (state) => {
    return state.list;
  }
}


// WEBPACK FOOTER //
// ./src/store/reminder/getters.js